'use client';
/** @jsxImportSource @emotion/react */

import type { CardMediaProps } from '@mui/material/CardMedia';

import MuiCardMedia from '@mui/material/CardMedia';

export type { CardMediaProps };
export const CardMedia = MuiCardMedia;
